
export class Socialusers {
    SocialID: string;
    FirstName: string;
    LastName: string;
    EmailID: string;
    Address: string;
    City: string;
    District: string;
    State: string;
    Zipcode: string;
    AuthToken: string;
    Provider: string;
    ContactNumber: string;
    Password : string;
    Country: string;
    Company : string;
    ClinicId : number;
    PersonMasterHashId: string;
    ID: string;        
    IsActive : number;
    DisplayCreatedDate : number;
    CreatedDate : number;
    CreatedBy : number;
    DisplayUpdatedDate : number;
    UpdatedDate : number;
    UpdatedBy : number;
    IsNewUser : number;
}
  